import Axios from "axios";
import React, { useEffect, useState } from "react";
import ActionButton from "../../modules/CustomizeComponent/ActionButton";

export default function SystemAdministration(){
    const [lawfirms, setLawfirms] = useState([]);
    
    useEffect(()=>{
        Axios.get('api/v2/test/lawfirms')
        .then((res)=>{
            let lawfirmsMapped = [];
            res.data.forEach((lawfirm, index) => {
                lawfirmsMapped.push({
                    lawfirm: lawfirm.lawfirm[0],
                    owner: lawfirm.owner[0]
                });
            });
            setLawfirms(lawfirmsMapped);
        });
    },[]);
    return(
        <div id="system-administration">
            
            <div className="card">
                <div className="card-body">
                    <h1 className="m-0">System Administration</h1>
                    <div className="mt-2 d-flex flex-row" style={{gap: '5px'}}>
                        <ActionButton className="btn btn-primary">Lawfirms</ActionButton>
                        <ActionButton className="btn btn-primary">Users</ActionButton>
                        <ActionButton className="btn btn-primary">Roles</ActionButton>
                        <ActionButton className="btn btn-primary">Modules</ActionButton>
                    </div>
                </div>
            </div>
            
            <div className="card my-6">
                <div className="card-body">
                    
                    <div className="row" style={{gap: '2px'}}>
                        <div className="card col-3">
                            <div className="card-body">
                                TEST
                            </div>
                        </div>
                        <div className="card col-3">
                            <div className="card-body">
                                TEST
                            </div>
                        </div>
                        <div className="card col-3">
                            <div className="card-body">
                                TEST
                            </div>
                        </div>
                        <div className="card col-3">
                            <div className="card-body">
                                TEST
                            </div>
                        </div>
                        <div className="card col-3">
                            <div className="card-body">
                                TEST
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}